



















































import Vue from "vue";
import Field from "@/components/basic/fields/Field.vue";
import Radio from "@/components/basic/fields/Radio.vue";
import TaxOfficeListField from "@/components/compositeFields/TaxOfficeListField.vue";
import { mapState } from "vuex";
import { FieldInterface } from "@/types";
import { PolandTaxResidenceFieldInterface } from "@/types";
import { TaxResidenceFlags } from "@/constants/tax-residence-flags";

export default Vue.extend({
  name: "PolandTaxResidenceField",
  props: {
    name: String,
    taxOfficeDataForeigner: Object,
    isPolandTaxCountry: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isTaxOfficesListOpen: false as boolean,
      isCitizenshipOtherThanPl : false as boolean,
      passedData: {
        key: "",
        value: "",
      } as FieldInterface,
      formData: {
        polandTaxOfficeId: "",
        polandTaxOfficeName: "",
        polandTaxResidentPesel: "",
      } as PolandTaxResidenceFieldInterface,
      TRANSLATION_KEY: "compositeFields.PolandTaxResidenceField",
    };
  },
  mounted() {
    this.returnService();
    this.isPeselRequiredForTaxResidence();
  },
  methods: {
    returnService(): void {
      const { firstPolandTaxOfficeId, firstPolandTaxOfficeName, secondPolandTaxOfficeId, secondPolandTaxOfficeName  } = this.taxResidenceData;
      if ((firstPolandTaxOfficeId && firstPolandTaxOfficeName)) {
        this.formData.polandTaxOfficeId = firstPolandTaxOfficeId;
        this.formData.polandTaxOfficeName = firstPolandTaxOfficeName;

        this.passedData.key = firstPolandTaxOfficeId;
        this.passedData.value = firstPolandTaxOfficeName;
      } else if(secondPolandTaxOfficeId && secondPolandTaxOfficeName) {
        this.formData.polandTaxOfficeId =  secondPolandTaxOfficeId;
        this.formData.polandTaxOfficeName = secondPolandTaxOfficeName;

        this.passedData.key = secondPolandTaxOfficeId;
        this.passedData.value = secondPolandTaxOfficeName;
      }

    },

    toggleTaxOfficesList(): void {
      this.isTaxOfficesListOpen = !this.isTaxOfficesListOpen;
    },

    closeTaxOfficeList(): void {
      this.isTaxOfficesListOpen = false;
    },
    setTaxOffice(data: FieldInterface): void {
      this.formData.polandTaxOfficeId = data.key;
      this.formData.polandTaxOfficeName = data.value;
      this.closeTaxOfficeList();
    },

    emitData(): void {
      (this as any).$emit("input", (this as any).formData);
    },
    isPeselRequiredForTaxResidence(): void {
      const { citizenship } = this.taxResidenceData;
      if(citizenship !== 'PL') {
        this.isCitizenshipOtherThanPl = true;
      }
    },
  },
  watch: {
    "formData.polandTaxOfficeId"(): void {
      (this as any).emitData();
    },

    "formData.polandTaxOfficeName"(): void {
      (this as any).emitData();
    },

    "formData.polandTaxResidentPesel"(): void {
      (this as any).emitData();
    },
  },
  computed: {
    ...mapState({
      taxResidenceData: (state: any) => state.formData,
    }),
  },
  components: {
    Field,
    Radio,
    TaxOfficeListField,
  },
});
